// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__qFcCp","deleteButtonWrapper":"styles_deleteButtonWrapper__zf99B"};